import { useNavigate } from "react-router-dom";
import type { MouseEvent, ReactNode } from "react";

interface DropdownItemProps {
  tag?: "a" | "button";
  to?: string;
  onClick?: () => void;
  onItemClick?: () => void;
  baseClassName?: string;
  className?: string;
  children: ReactNode;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
  tag = "button",
  to,
  onClick,
  onItemClick,
  baseClassName = "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer rounded-lg",
  className = "",
  children,
}) => {
  const combinedClasses = `${baseClassName} ${className}`.trim();
  const navigate = useNavigate();
  // reference 'tag' to avoid unused warning (legacy prop for compatibility)
  void tag;

  const handleClick = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    event.preventDefault();
    try {
      if (to) {
        navigate(to);
      }
    } catch {}
    onClick?.();
    onItemClick?.();
  };

  return (
    <button type="button" onClick={handleClick} className={`${combinedClasses} cursor-pointer pointer-events-auto`} role="menuitem" tabIndex={0} style={{ cursor: 'pointer' }}>
      {children}
    </button>
  );
}
